import { render, staticRenderFns } from "./TripInfo.vue?vue&type=template&id=18fa7972&scoped=true"
import script from "./TripInfo.vue?vue&type=script&lang=js"
export * from "./TripInfo.vue?vue&type=script&lang=js"
import style0 from "./TripInfo.vue?vue&type=style&index=0&id=18fa7972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fa7972",
  null
  
)

export default component.exports